import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {Subscription} from 'rxjs';
import {QuestionsService} from 'src/app/services/questions.service';
import {LoaderService} from '../../../services/loader.service';
import {VisitorQuestion} from '../../../types/VisitorQuestion';
import {ModalsControlService} from '../../../services/modals-control.service';
import {ModalCommand} from '../../../types/ModalCommand';
import {ModalTypeEnum} from '../../../enums/ModalEnums';
import {InfoModalContent} from '../../../types/InfoModalContent';
import {finalize} from 'rxjs/operators';
import {LoaderQueueItem} from '../../../types/LoaderQueueItem';

@Component({
  selector: 'app-ask',
  templateUrl: './ask.component.html',
  styleUrls: ['./ask.component.scss'],
})
export class AskComponent implements OnInit, OnDestroy {
  askForm: UntypedFormGroup;
  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<AskComponent>,
    @Inject(MAT_DIALOG_DATA) public careproviderUnitId: number,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private questionsService: QuestionsService,
    private modalControl: ModalsControlService,
  ) {}

  ngOnInit(): void {
    this.buildAskForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  saveQuestion(): void {
    (Object as any).values(this.askForm.controls).forEach((control) => control.markAllAsTouched());
    if (this.askForm.valid) {
      const queryId: number = this.loaderService.generateQueueId();
      const queryItem: LoaderQueueItem = {
        id: queryId,
        title: '',
        description: '',
      };
      this.loaderService.addToQueue(queryItem);
      this.subscriptions.push(
        this.questionsService
          .AddQuestion(this.getQuestionObjectFromFormData())
          .pipe(
            finalize(() => {
              this.loaderService.removeFromQueue(queryId);
            }),
          )
          .subscribe(
            (result) => this.processQuestionData(result),
            (error) => console.error(error),
          ),
      );
    }
  }

  private processQuestionData(result: VisitorQuestion): void {
    this.openInfoModal();
    this.dialogRef.close();
  }

  private openInfoModal(): void {
    const infoContent: InfoModalContent = {
      title: 'Tack för din fråga!',
      message:
        '<p>Du kommer att få ett svar skickat till den e-post adress du angav så fort vårdgivaren besvarar frågan.</p>',
    };
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum.INFO,
      data: infoContent,
    };
    this.modalControl.openModal(modalCommand);
  }

  private buildAskForm(): void {
    this.askForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      question: ['', [Validators.required]],
      isPublic: [false, []],
      datapolicy: [false, [Validators.pattern('true')]],
    });
  }

  private getQuestionObjectFromFormData(): VisitorQuestion {
    const question: VisitorQuestion = {
      email: this.askForm.value.email,
      question: this.askForm.value.question,
      isPublic: this.askForm.value.isPublic,
      caregiverUnitId: this.careproviderUnitId,
      careServiceId: null,
    };
    return question;
  }
}
